<form #myForm="ngForm">
    <div class="flex-row tight responsive">
        <div class="field">
            <label for="ethnicity" class="">What is your race and/or ethnicity? (Select all that apply.)</label>
            <checkbox-list id="ethnicity" name="ethnicity" [allOptions]="allOptions" [(selectedOptions)]="selectedOptions" (selectedOptionsChange)="onSelectedOptionsChange($event)"></checkbox-list>
        </div>
    </div>
</form>
